export default {"src":"/_next/static/image/src/assets/icons/filter-icons/television.2e2a749eb1d73c7a4a058602216066c0.svg","height":32,"width":32};